(function () {
  document.querySelectorAll('[id^="custom-fv-"]').forEach(function (fv) {
    var track    = fv.querySelector('[id^="fv-track-"]');
    var slides   = fv.querySelectorAll('.custom-fv__slide');
    var dots     = fv.querySelectorAll('.custom-fv__dot');
    var prevBtn  = fv.querySelector('[id^="fv-prev-"]');
    var nextBtn  = fv.querySelector('[id^="fv-next-"]');
    var progBar  = fv.querySelector('.custom-fv__progress-bar');
    if (!slides.length) return;

    var current   = 0;
    var total     = slides.length;
    var autoplay  = fv.dataset.autoplay === 'true';
    var interval  = parseInt(fv.dataset.interval) || 5000;
    var transition = fv.dataset.transition || 'fade';
    var timer, progTimer;

    function goTo(idx, dir) {
      var prev = current;
      current = (idx + total) % total;
      slides[prev].classList.remove('is-active');
      if (transition === 'slide') {
        slides[prev].classList.add('is-prev');
        setTimeout(function () { slides[prev].classList.remove('is-prev'); }, 750);
      }
      slides[current].classList.add('is-active');
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
      if (progBar) startProgress();
    }

    function startProgress() {
      if (!progBar) return;
      progBar.style.transition = 'none';
      progBar.style.width = '0';
      clearTimeout(progTimer);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          progBar.style.transition = 'width ' + interval + 'ms linear';
          progBar.style.width = '100%';
        });
      });
    }

    function startAuto() {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(function () { goTo(current + 1); }, interval);
    }

    /* 初期化 */
    slides[0].classList.add('is-active');
    startProgress();
    startAuto();

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); startAuto(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); startAuto(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); startAuto(); });
    });

    /* スワイプ */
    var sx = 0;
    fv.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    fv.addEventListener('touchend', function (e) {
      var diff = sx - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) { goTo(diff > 0 ? current + 1 : current - 1); startAuto(); }
    });

    /* ホバーで一時停止 */
    fv.addEventListener('mouseenter', function () { clearInterval(timer); });
    fv.addEventListener('mouseleave', startAuto);
  });
})();
